import { client } from "../../client";
import {
  TransactionStatus,
  BillType,
  PaymentStatus,
  BillFileInfo,
} from "./financials-types";

export interface Transaction {
  id: string;
  type: string;
  status: TransactionStatus;
  resolvedDttm: string | null;
  createdDttm: string;
  dueDt: string | null;
  currency: string;
  amount: string;
  isCancelled: boolean;
  isCancellation: boolean;
  accountBalance: string | null;
  description: string | null;
  reference: string | null;
  cancellationDttm: string | null;
}

export interface Payment extends Transaction {
  method: string;
  paymentStatus: PaymentStatus;
}

export interface BillTransaction extends Transaction {
  billType: BillType;
  number: string | null;
  billNumber: string | null;
  fromDttm: string | null;
  toDttm: string | null;
  issueDt: string;
  files: BillFileInfo[];
}

export interface AccountTransactions {
  results: Transaction[];
}

export const TRANSACTION_TYPES = [
  "Payment",
  "Bill",
  "CreditNote",
  "Account Credit",
  "Account Debit",
  "Repayment",
  "Dunning Charge",
  "Incoming Balance Transfer",
  "Outgoing Balance Transfer",
  "Deposit",
  "Write Off",
  "Credit Write Off",
  "PAYG Transfer",
  "Write On",
];

export const getAccountTransactions = (
  key: string,
  {
    page,
    size,
    accountNumber,
  }: { page: number; size: number; accountNumber: string },
) => {
  const params = { page: String(page), size: String(size) };
  return client
    .get<AccountTransactions>(
      `accounts/${accountNumber}/transactions?${new URLSearchParams(
        params,
      ).toString()}`,
    )
    .then((response) => {
      return {
        results: response?.data?.results,
        totalCount: response?.headers["x-total-count"],
      };
    });
};
